const statics = [
  {
    id: 1,
    name: " Today : In",
    count: 28,
    color: "#FDA686",
    shade: "#FFF1EA",
  },
  {
    id: 2,
    name: "Today : Out",
    count: 20,
    color: "#FDA686",
    shade: "#FFF1EA",
  },
  {
    id: 3,
    name: "Today : Total",
    count: 48,
    color: "#FDA686",
    shade: "#FFF1EA",
  },
  {
    id: 4,
    name: "Previous : In",
    count: 12,
    color: "#FDA686",
    shade: "#FFF1EA",
  },
  {
    id: 5,
    name: "Previous : Out",
    count: 7,
    color: "#FDA686",
    shade: "#FFF1EA",
  },
  {
    id: 6,
    name: "Total : Remain",
    count: 28 + (12 - 7),
    color: "#FDA686",
    shade: "#FFF1EA",
  },
  // {
  //   id: 6,
  //   name: "Total Remain",
  //   count: 47,
  //   color: "#FDA686",
  //   shade: "#FFF1EA",
  // },
  // {
  //   id: 6,
  //   name: "Total Remain",
  //   count: 47,
  //   color: "#FDA686",
  //   shade: "#FFF1EA",
  // },
];
const onpremises = [
  { id: 1 },
  { id: 2 },
  { id: 3 },
  { id: 4 },
  { id: 5 },
  { id: 6 },
  { id: 7 },
  { id: 8 },
  { id: 9 },
  { id: 10 },
  { id: 11 },
  { id: 12 },
  { id: 13 },
  { id: 14 },
  { id: 15 },
  { id: 16 },
  { id: 17 },
  { id: 18 },
  { id: 19 },
  { id: 20 },
  { id: 21 },
  { id: 22 },
  { id: 23 },
  { id: 24 },
];

const accessLevels = [
  { id: 0 },
  { id: 1 },
  { id: 2 },
  { id: 3 },
  { id: 4 },
  { id: 5 },
  { id: 6 },
  { id: 7 },
  { id: 8 },
  { id: 9 },
];

const companies = [
  { code: 1, name: "Toyota Tanzania Ltd" },
  { code: 2, name: "Automark Ltd" },
  { code: 3, name: "Salute Properties Ltd" },
  { code: 4, name: "Salute Finance Ltd" },
  { code: 5, name: "City Motors (Tanzania) Limited" },
  { code: 6, name: "Jacaranda Development Ltd" },
  { code: 7, name: "The Overhang" },
  { code: 8, name: "Sunbeam Auto Ltd" },
  { code: 9, name: "Karimjee Jivanjee Ltd - Kenya" },
  { code: 10, name: "Karimjee Jivanjee Ltd - Uganda" },
];

const dummyexpense: any = [
  {
    date: "Jan",
    name: "January",
    expenses: 12000000,
    budget: 0,
    amt: 2000,
    list: [],
  },
  {
    date: "Feb",
    name: "February",
    expenses: 14000000,
    budget: 0,
    amt: 2000,
    list: [],
  },
  {
    date: "Mar",
    name: "March",
    expenses: 7500000,
    budget: 0,
    amt: 2000,
    list: [],
  },
  {
    date: "Apr",
    name: "April",
    expenses: 6470000,
    budget: 0,
    amt: 2000,
    list: [],
  },
  {
    date: "May",
    name: "May",
    expenses: 7658877,
    budget: 0,
    amt: 2000,
    list: [],
  },
  {
    date: "Jun",
    name: "June",
    expenses: 12800000,
    budget: 0,
    amt: 2000,
    list: [],
  },
  {
    date: "Jul",
    name: "July",
    expenses: 7890000,
    budget: 0,
    amt: 2000,
    list: [],
  },
  {
    date: "Aug",
    name: "August",
    expenses: 8907666,
    budget: 0,
    amt: 2000,
    list: [],
  },
  {
    date: "Sep",
    name: "September",
    expenses: 250000,
    budget: 0,
    amt: 2000,
    list: [],
  },
  {
    date: "Oct",
    name: "October",
    expenses: 7900000,
    budget: 0,
    amt: 2000,
    list: [],
  },
  {
    date: "Nov",
    name: "November",
    expenses: 560000,
    budget: 0,
    amt: 2000,
    list: [],
  },
  {
    date: "Dec",
    name: "December",
    expenses: 890000,
    budget: 0,
    amt: 2000,
    list: [],
  },
];

const dummyexpenses: any = [
  {
    date: "Jan",
    name: "January",
    expenses: 0,
    budget: 0,
    amt: 2000,
  },
  {
    date: "Feb",
    name: "February",
    expenses: 0,
    budget: 0,
    amt: 2000,
  },
  {
    date: "Mar",
    name: "March",
    expenses: 0,
    budget: 0,
    amt: 2000,
  },
  {
    date: "Apr",
    name: "April",
    expenses: 0,
    budget: 0,
    amt: 2000,
  },
  {
    date: "May",
    name: "May",
    expenses: 0,
    budget: 0,
    amt: 2000,
  },
  {
    date: "Jun",
    name: "June",
    expenses: 0,
    budget: 0,
    amt: 2000,
  },
  {
    date: "Jul",
    name: "July",
    expenses: 0,
    budget: 0,
    amt: 2000,
  },
  {
    date: "Aug",
    name: "August",
    expenses: 0,
    budget: 0,
    amt: 2000,
  },
  {
    date: "Sep",
    name: "September",
    expenses: 0,
    budget: 0,
    amt: 2000,
  },
  {
    date: "Oct",
    name: "October",
    expenses: 0,
    budget: 0,
    amt: 2000,
  },
  {
    date: "Nov",
    name: "November",
    expenses: 0,
    budget: 0,
    amt: 2000,
  },
  {
    date: "Dec",
    name: "December",
    expenses: 0,
    budget: 0,
    amt: 2000,
  },
];

const checkpoints = [
  {
    id: 1,
    name: "Express Lane",
    vehicles: [
      { id: 1, regno: "T127DED" },
      { id: 2, regno: "T325DFC" },
      { id: 3, regno: "T527CRD" },
      { id: 4, regno: "T727BUD" },
      { id: 5, regno: "T627DKL" },
      { id: 6, regno: "T327DMN" },
      { id: 7, regno: "T827DFG" },
      { id: 8, regno: "T927DJK" },
      { id: 9, regno: "T237DOL" },
    ],
  },
  {
    id: 2,
    name: "Workshop 1",
    vehicles: [
      { id: 1, regno: "T827CDS" },
      { id: 2, regno: "T325BRD" },
      { id: 3, regno: "T527CRD" },
      { id: 4, regno: "T727BUD" },
      { id: 5, regno: "T627CRD" },
      { id: 6, regno: "T327ARD" },
      { id: 7, regno: "T827BDD" },
      { id: 8, regno: "T927DRD" },
      { id: 9, regno: "T237DOD" },
      { id: 10, regno: "T537DRD" },
    ],
  },
  {
    id: 3,
    name: "Workshop 2",
    vehicles: [
      { id: 1, regno: "T127BRD" },
      { id: 2, regno: "T127BRD" },
      { id: 3, regno: "T127BRD" },
      { id: 4, regno: "T127BRD" },
      { id: 5, regno: "T127BRD" },
      { id: 6, regno: "T127BRD" },
      { id: 7, regno: "T127BRD" },
      { id: 8, regno: "T127BRD" },
    ],
  },
  {
    id: 4,
    name: "Workshop 3",
    vehicles: [
      { id: 1, regno: "T127BRD" },
      { id: 2, regno: "T127BRD" },
      { id: 3, regno: "T127BRD" },
      { id: 4, regno: "T127BRD" },
      { id: 5, regno: "T127BRD" },
      { id: 6, regno: "T127BRD" },
      { id: 7, regno: "T127BRD" },
      { id: 8, regno: "T127BRD" },
      { id: 9, regno: "T127BRD" },
      { id: 10, regno: "T127BRD" },
    ],
  },
  {
    id: 5,
    name: "Washing Bay",
    vehicles: [
      { id: 1, regno: "T127BRD" },
      { id: 2, regno: "T127BRD" },
      { id: 3, regno: "T127BRD" },
      { id: 4, regno: "T127BRD" },
      { id: 5, regno: "T127BRD" },
      { id: 6, regno: "T127BRD" },
      { id: 7, regno: "T127BRD" },
      { id: 8, regno: "T127BRD" },
      { id: 9, regno: "T127BRD" },
      { id: 10, regno: "T127BRD" },
    ],
  },
  {
    id: 6,
    name: "Body and Paint Center",
    vehicles: [
      { id: 1, regno: "T127BRD" },
      { id: 2, regno: "T325BRD" },
      { id: 3, regno: "T527CRD" },
      { id: 4, regno: "T727BUD" },
      { id: 5, regno: "T627CRD" },
      { id: 6, regno: "T327ARD" },
      { id: 7, regno: "T827BDD" },
      { id: 8, regno: "T927DRD" },
      { id: 9, regno: "T237DOD" },
      { id: 10, regno: "T537DRD" },
    ],
  },
  {
    id: 7,
    name: "Waiting for customer approval",
    vehicles: [
      { id: 1, regno: "T389BRD" },
      { id: 2, regno: "T927BRD" },
      { id: 3, regno: "T835BRD" },
      { id: 4, regno: "T450BRD" },
      { id: 5, regno: "T227BRD" },
      { id: 6, regno: "T197BRD" },
      { id: 7, regno: "T827BRD" },
      { id: 8, regno: "T267DSD" },
      { id: 9, regno: "T827CUD" },
      { id: 10, regno: "T027BRX" },
    ],
  },
  {
    id: 8,
    name: "Testing Lane",
    vehicles: [
      { id: 1, regno: "T127BRD" },
      { id: 2, regno: "T127BRD" },
      { id: 3, regno: "T127BRD" },
      { id: 4, regno: "T127BRD" },
      { id: 5, regno: "T127BRD" },
      { id: 6, regno: "T127BRD" },
      { id: 7, regno: "T127BRD" },
      { id: 8, regno: "T127BRD" },
      { id: 9, regno: "T127BRD" },
      { id: 10, regno: "T127BRD" },
    ],
  },
  // {
  //   id: 9,
  //   name: "Express Lane",
  //   vehicles: [
  //     { id: 1, regno: "T127BRD" },
  //     { id: 2, regno: "T127BRD" },
  //     { id: 3, regno: "T127BRD" },
  //     { id: 4, regno: "T127BRD" },
  //     { id: 5, regno: "T127BRD" },
  //     { id: 6, regno: "T127BRD" },
  //     { id: 7, regno: "T127BRD" },
  //     { id: 8, regno: "T127BRD" },
  //     { id: 9, regno: "T127BRD" },
  //     { id: 10, regno: "T127BRD" },
  //   ],
  // },
];

const widgets = [
  { id: 1, count: 47, name: "Total Companies" },
  { id: 2, count: 39, name: "Total Vehicle Visited" },
  { id: 3, count: 28, name: "Vehicle not exited" },
  { id: 4, count: 32, name: "Vehicle Booked" },
];

const four = [{ id: 1 }, { id: 2 }, { id: 3 }];

const menus = [
  { id: 1, isActive: true, to: "/manage/customers", name: "Customers" },
  { id: 2, isActive: false, to: "/manage/bookings", name: "Bookings" },
  { id: 3, isActive: false, to: "/manage/quotations", name: "Quotations" },
  {
    id: 12,
    isActive: false,
    to: "/manage/requests",
    name: "New Accounts",
  },
  { id: 4, isActive: false, to: "/manage/assists", name: "Road Assist" },
  { id: 5, isActive: false, to: "/manage/testdrives", name: "Test Drives" },
  { id: 14, isActive: false, to: "/manage/budgets", name: "Budgets" },
  { id: 6, isActive: false, to: "/manage/users", name: "Users" },
  { id: 7, isActive: false, to: "/manage/roles", name: "Roles" },
  { id: 8, isActive: false, to: "/manage/models", name: "Models" },
  { id: 9, isActive: false, to: "/manage/vehicles", name: "Vehicles" },
  { id: 10, isActive: false, to: "/manage/sites", name: "Sites" },
  { id: 11, isActive: false, to: "/manage/qrcodes", name: "QR Codes" },
];

const centers = [
  {
    _id: 1,
    name: "IT Department",
    title: "Infromation Technology",
    subtitle: "IT Department",
    code: 87,
  },
  {
    _id: 21,
    name: "HR Department",
    title: "Human Resource",
    subtitle: "HR Department",
    code: 88,
  },
  {
    _id: 2,
    name: "Parts Department",
    title: "Parts Department",
    subtitle: "Parts Department",
    code: 30,
  },
  {
    _id: 3,
    name: "Service Department",
    title: "Service Department",
    subtitle: "Service Department",
    code: 40,
  },
  {
    _id: 20,
    name: "Bodyshop Department",
    title: "Bodyshop Department",
    subtitle: "Bodyshop Department",
    code: 37,
  },
  {
    _id: 4,
    name: "Marketing Department",
    title: "Marketing Department",
    subtitle: "Marketing Department",
    code: 86,
  },
  {
    _id: 22,
    name: "Training Department",
    title: "Training Department",
    subtitle: "Training Department",
    code: 89,
  },
  {
    _id: 7,
    name: "Clearing & Forwarding",
    title: "Clearing & Forwarding",
    subtitle: "Clearing & Forwarding",
    code: 50,
  },
  {
    _id: 7,
    name: "Operations Department",
    title: "Operations Department",
    subtitle: "Operations Department",
    code: 91,
  },
  {
    _id: 8,
    name: "Used vehicles",
    title: "Used vehicles",
    subtitle: "Used vehicles",
    code: 15,
  },
  {
    _id: 9,
    name: "Operating Lease Sales",
    title: "Operating Lease Sales",
    subtitle: "Operating Lease Sales",
    code: 20,
  },
  {
    _id: 9,
    name: "Finance Lease Sales",
    title: "Finance Lease Sales",
    subtitle: "Finance Department",
    code: 21,
  },
  {
    _id: 5,
    name: "Vehicle Sales - Consignment",
    title: "Vehicle Sales - Consignment",
    subtitle: "Consignment",
    code: 10,
  },
  {
    _id: 6,
    name: "Vehicle Sales - Ex Factory",
    title: "Vehicle Sales - Ex Factory",
    subtitle: "Ex Factory",
    code: 11,
  },
  {
    _id: 7,
    name: "Distribution Service Department",
    title: "Distribution Service Department",
    subtitle: "Distribution Service Department",
    code: 90,
  },
  {
    _id: 9,
    name: "Administration Department",
    title: "Administration Department",
    subtitle: "Administration Department",
    code: 80,
  },
  {
    _id: 9,
    name: "Admin Department - Security",
    title: "Admin Department - Security",
    subtitle: "Security",
    code: 81,
  },
  {
    _id: 9,
    name: "Admin Department - Acct & Finance",
    title: "Admin Department - Acct & Finance",
    subtitle: "Acct & Finance",
    code: 82,
  },
  {
    _id: 9,
    name: "Admin Department - CM",
    title: "Admin Department - CM",
    subtitle: "CM",
    code: 83,
  },
  {
    _id: 9,
    name: "Admin Department - MD",
    title: "Admin Department - MD",
    subtitle: "MD",
    code: 84,
  },
  {
    _id: 9,
    name: "Hino Department",
    title: "Hino Department",
    subtitle: "Hino",
    code: 85,
  },
];

const departments = [
  { id: 1, name: "IT" },
  { id: 2, name: "Property - TTL" },
  { id: 3, name: "Administration" },
  { id: 4, name: "Property" },
  { id: 5, name: "Management" },
  { id: 6, name: "Marketing" },
  { id: 7, name: "Finance" },
  { id: 8, name: "Parts" },
  { id: 9, name: "Sales" },
  { id: 10, name: "AfterSales" },
  { id: 11, name: "Audit" },
  { id: 12, name: "Legal" },
  { id: 13, name: "Service" },
  { id: 14, name: "Automark" },
  { id: 15, name: "KJL - Kenya" },
  { id: 16, name: "Sunbeam" },
  { id: 17, name: "Salute Property Ltd" },
  { id: 18, name: "Salute Finance" },
  { id: 19, name: "Jacaranda" },
  { id: 20, name: "Business Improvement" },
  { id: 21, name: "Business Development" },
  { id: 22, name: "Service & BodyShop" },
  { id: 23, name: "Clearing & Forwarding" },
  { id: 24, name: "Body & Paint" },
  { id: 25, name: "CRM" },
  { id: 26, name: "CML" },
  { id: 27, name: "Project" },
];

export {
  statics,
  onpremises,
  four,
  checkpoints,
  widgets,
  companies,
  menus,
  dummyexpenses,
  dummyexpense,
  accessLevels,
  centers,
  departments,
};
